module.exports = __webpack_public_path__ + "img/section1-2ListRight.c1300804.svg";